import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import OKomBreadcrumb from '../Components/OsloKommuneUI/OKomBreadcrumb';
import RegistrationPeriodSection from '../Components/RegistrationPeriodSection';

const ExamConfigView: React.FC<RouteComponentProps> = () => {
  useEffect(() => {
    document.title = 'Konfigurasjon — Eksamen';
  }, []);

  return (
    <>
      <OKomBreadcrumb path='Konfigurasjon, Eksamen'></OKomBreadcrumb>
      <div className="ods-margin-top-25">
        <RegistrationPeriodSection eventType="exam" />
      </div>
    </>
  );
};

export default withRouter(ExamConfigView);
